import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
import { convertModelToFormData } from '@application/helpers/form-data-helper';
const mapFormFieldsToApi = (formFields) => {
    if (!Array.isArray(formFields))
        return [];
    return formFields.map((field) => ({
        Id: field.id,
        Label: field.label,
        LabelTranslations: (field.labelTranslations || []).map((lt) => ({
            LanguageId: lt.languageId ?? lt.languageCode,
            Label: lt.label,
            descriptionForToolTip: lt.descriptionForToolTip
        })),
        descriptionForToolTip: field.descriptionForToolTip,
        UndertakingTranslations: (field.undertakingTranslations || []).map((ut) => ({
            LanguageId: ut.languageId ?? ut.languageCode,
            UndertakingToggleLabel: ut.undertakingToggleLabel,
            UndertakingAlertNote: ut.undertakingAlertNote
        })),
        FieldType: field.fieldType,
        IsRequired: field.isRequired,
        IsIdentity: field.isIdentity,
        IsUniqueEmail: field.isUniqueEmail,
        IsUniquePhoneNumber: field.isUniquePhoneNumber,
        FormStepId: field.formStepId,
        FormStepName: field.formStepName,
        Description: field.description,
        FieldParent: field.fieldParent,
        FieldChild: field.fieldChild,
        FieldOrder: field.fieldOrder,
        FieldAdditionalNote: field.fieldAdditionalNote,
        UndertakingToggleLabel: field.undertakingToggleLabel,
        UndertakingAlertNote: field.undertakingAlertNote,
        Options: (field.options || []).map((opt) => ({
            Id: opt.id,
            Label: opt.label,
            LabelTranslations: (opt.labelTranslations || []).map((lt) => ({
                LanguageId: lt.languageId ?? lt.languageCode,
                Label: lt.label
            })),
            Value: opt.value
        })),
        ...(field.fieldType === 'companyDropdown' || field.fieldType === '18'
            ? {
                ReferredByFields: field.companyDropdownFields && field.companyDropdownFields.length > 0
                    ? field.companyDropdownFields
                        .filter((cdf) => cdf.enabled) // Only send enabled fields
                        .map((cdf) => ({
                        Id: cdf.backendId || undefined,
                        Label: cdf.label,
                        LabelTranslations: (cdf.labelTranslations || []).map((lt) => ({
                            LanguageId: lt.languageId ?? lt.languageCode,
                            Label: lt.label
                        })),
                        FieldType: '1',
                        Enabled: cdf.enabled,
                        Required: cdf.required && cdf.enabled
                    }))
                    : []
            }
            : {}),
        ParentOptionId: field.parentOptionId ?? null,
        ParentOptionIds: Array.isArray(field.parentOptionIds) ? field.parentOptionIds : [],
        ParentFieldId: field.parentFieldId ?? null,
        ParentFieldLabel: field.parentFieldLabel ?? null,
        ParentOptionValue: field.parentOptionValue ?? null,
        IsBranchingEnabled: field.isBranchingEnabled ?? false,
        IsEnabled: field.isEnabled ?? true,
        RelatedFormFieldId: field.relatedFormFieldId,
        MaxAdditionalAttendees: field.maxAdditionalAttendees ?? null,
        MaxAdditionalAttendeesReachedMessage: field.maxAdditionalAttendeesReachedMessage ?? null,
        SubFieldRole: field.subFieldRole ?? null
    }));
};
const createFormField = (formFieldRequest) => {
    const mappedRequest = {
        FormFields: mapFormFieldsToApi(formFieldRequest.formFields),
        BackgroundImages: formFieldRequest.backgroundImages?.map((img) => ({
            Image: img.image,
            IsBackgroundImage: img.isBackgroundImage
        })),
        ExistingImages: formFieldRequest.existingImages?.map((img) => ({
            Id: img.id,
            IsBackgroundImage: img.isBackgroundImage
        })),
        EventId: formFieldRequest.eventId
    };
    const formData = convertModelToFormData(mappedRequest);
    // Add undertaking files to FormData
    if (formFieldRequest.undertakingFiles && formFieldRequest.undertakingFiles.length > 0) {
        formFieldRequest.undertakingFiles.forEach((file, index) => {
            formData.append(`UndertakingFiles[${index}]`, file);
        });
        // Append languages aligned by index if provided
        if (formFieldRequest.undertakingFilesLanguages &&
            formFieldRequest.undertakingFilesLanguages.length > 0) {
            formFieldRequest.undertakingFilesLanguages.forEach((langId, index) => {
                formData.append(`UndertakingFilesLanguages[${index}]`, langId);
            });
        }
    }
    return vdkEmHappinessPortalApi.post('/form-fields/create', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const updateFormField = (formField) => {
    const mappedRequest = {
        FormFields: mapFormFieldsToApi(formField.formFields),
        BackgroundImages: formField.backgroundImages?.map((img) => ({
            Image: img.image,
            IsBackgroundImage: img.isBackgroundImage
        })),
        ExistingImages: formField.existingImages?.map((img) => ({
            Id: img.id,
            IsBackgroundImage: img.isBackgroundImage
        })),
        EventId: formField.eventId
    };
    const formData = convertModelToFormData(mappedRequest);
    // Add undertaking files to FormData
    if (formField.undertakingFiles && formField.undertakingFiles.length > 0) {
        formField.undertakingFiles.forEach((file, index) => {
            formData.append(`UndertakingFiles[${index}]`, file);
        });
        // Append languages aligned by index if provided
        if (formField.undertakingFilesLanguages && formField.undertakingFilesLanguages.length > 0) {
            formField.undertakingFilesLanguages.forEach((langId, index) => {
                formData.append(`UndertakingFilesLanguages[${index}]`, langId);
            });
        }
    }
    return vdkEmHappinessPortalApi.put('/form-fields/update', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
const deleteFormField = (id) => {
    return vdkEmHappinessPortalApi.delete(`/form-fields/${id}`);
};
const getFormFieldById = (id) => {
    return vdkEmHappinessPortalApi.get(`/form-fields/${id}`);
};
const getFormFieldsByFormStepId = (formStepId) => {
    return vdkEmHappinessPortalApi.get(`/form-fields-by-form-step-id/${formStepId}`);
};
const getIdentityFormFieldsByEventId = (request) => {
    return vdkEmHappinessPortalApi.get(`/form-fields/identity/${request.eventId}`, { params: { languageId: request.languageId, templateType: request.templateType } });
};
const formFieldAPI = {
    createFormField,
    updateFormField,
    deleteFormField,
    getFormFieldById,
    getFormFieldsByFormStepId,
    getIdentityFormFieldsByEventId
};
export default formFieldAPI;
